export default function AtopalmBrandSection() {
  return (
    <section className="mt-20 border-t border-gray-100 pt-16">
      {/* Brand Header */}
      <div className="text-center mb-14">
        <span className="inline-block text-[11px] font-bold tracking-[0.3em] uppercase px-4 py-1.5 rounded-full mb-4" style={{ backgroundColor: '#F0EAE0', color: '#8C7D6E' }}>
          Brand Story
        </span>
        <h2 className="text-3xl md:text-4xl font-black text-gray-900 tracking-tight mb-2">ATOPALM</h2>
        <p className="text-lg text-gray-400 tracking-widest font-medium">爱多邦 / 아토팜</p>
        <p className="mt-4 text-[14px] text-gray-500 leading-relaxed max-w-2xl mx-auto">
          皮肤科学为基础的专业护肤品牌 · 피부과학 기반의 더마 코스메틱 브랜드
        </p>
      </div>

      {/* MLE Technology Highlight */}
      <div className="rounded-3xl overflow-hidden mb-12" style={{ background: 'linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%)' }}>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0">
          <div className="p-10 lg:p-14 flex flex-col justify-center">
            <span className="inline-block text-[10px] font-bold tracking-[0.3em] uppercase px-3 py-1 rounded-full mb-6 w-fit" style={{ backgroundColor: 'rgba(255,255,255,0.1)', color: '#D4C9B8' }}>
              Core Technology
            </span>
            <h3 className="text-3xl md:text-4xl font-black text-white leading-tight mb-4 tracking-tight">
              MLE<br />
              <span className="text-2xl font-bold" style={{ color: '#C8B89A' }}>Multi-Lamellar Emulsion</span>
            </h3>
            <p className="text-[13px] leading-relaxed mb-2" style={{ color: '#A09080' }}>多层乳化技术 / 다층 구조 에멀전 기술</p>
            <p className="text-[14px] text-gray-300 leading-relaxed mt-4">
              模仿人体皮肤脂质结构的创新技术，从根本上修复受损皮肤屏障。
            </p>
            <p className="text-[13px] leading-relaxed mt-2" style={{ color: '#7A6A5A' }}>
              인체 피부의 지질 구조를 그대로 모방한 혁신적인 기술로, 손상된 피부 장벽을 근본적으로 회복시킵니다.
            </p>
            <div className="flex flex-wrap gap-2 mt-6">
              {[
                { zh: '皮肤屏障重建', ko: '피부 장벽 재건' },
                { zh: '阻止水分流失', ko: '수분 손실 차단' },
                { zh: '舒缓刺激', ko: '자극 완화' },
                { zh: '临床验证', ko: '임상 검증' },
              ].map((tag) => (
                <span key={tag.zh} className="text-[11px] px-3 py-1 rounded-full font-medium" style={{ backgroundColor: 'rgba(200,184,154,0.15)', color: '#C8B89A', border: '1px solid rgba(200,184,154,0.2)' }}>
                  {tag.zh} <span style={{ opacity: 0.6 }}>/ {tag.ko}</span>
                </span>
              ))}
            </div>
          </div>
          <div className="p-10 lg:p-14 flex flex-col justify-center gap-5" style={{ borderLeft: '1px solid rgba(255,255,255,0.06)' }}>
            {[
              { num: '01', titleZh: '模仿皮肤脂质结构', titleKo: '피부 지질 모방 구조', descZh: '以神经酰胺、胆固醇、脂肪酸的最佳比例形成与皮肤脂质相同的多层结构', descKo: '세라마이드, 콜레스테롤, 지방산의 최적 비율로 피부 지질과 동일한 다층 구조 형성' },
              { num: '02', titleZh: '即时修复皮肤屏障', titleKo: '피부 장벽 즉각 회복', descZh: '直接作用于受损皮肤屏障，阻止水分流失，保护皮肤免受外部刺激', descKo: '손상된 피부 장벽에 직접 작용하여 수분 손실을 차단하고 외부 자극으로부터 피부를 보호' },
              { num: '03', titleZh: '持久保湿效果', titleKo: '지속적인 보습 효과', descZh: '深入渗透皮肤，长时间持续保湿效果，维持健康肌肤状态', descKo: '피부 깊숙이 침투하여 장시간 지속되는 보습 효과로 건강한 피부 상태를 유지' },
            ].map((item) => (
              <div key={item.num} className="flex gap-4">
                <span className="text-[11px] font-black shrink-0 mt-0.5" style={{ color: '#C8B89A' }}>{item.num}</span>
                <div>
                  <p className="text-[13px] font-bold text-white mb-0.5">{item.titleZh}</p>
                  <p className="text-[11px] mb-1.5" style={{ color: '#7A6A5A' }}>{item.titleKo}</p>
                  <p className="text-[12px] leading-relaxed" style={{ color: '#8A7A6A' }}>{item.descZh}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Brand Values */}
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-12">
        {[
          { icon: 'ri-microscope-line', titleZh: '皮肤科学基础', titleKo: '피부과학 기반', descZh: '与皮肤科专家共同研发的专业护肤品', descKo: '피부과 전문의와 공동 연구·개발한 더마 코스메틱' },
          { icon: 'ri-test-tube-line', titleZh: '临床测试完成', titleKo: '임상 테스트 완료', descZh: '所有产品经皮肤科专家临床测试及安全性验证', descKo: '모든 제품 피부과 전문의 임상 테스트 및 안전성 검증' },
          { icon: 'ri-leaf-line', titleZh: '低刺激成分', titleKo: '저자극 성분', descZh: '敏感肌肤也可安心使用的温和成分', descKo: '민감한 피부도 안심하고 사용할 수 있는 순한 성분' },
          { icon: 'ri-global-line', titleZh: '全球出口品牌', titleKo: '글로벌 수출 브랜드', descZh: '出口中国·美国·东南亚等全球30多个国家', descKo: '중국·미국·동남아 등 전 세계 30개국 이상 수출' },
        ].map((item) => (
          <div key={item.titleZh} className="rounded-2xl p-6 text-center" style={{ backgroundColor: '#FAFAF8', border: '1px solid #EDE8E0' }}>
            <div className="w-12 h-12 flex items-center justify-center rounded-2xl mx-auto mb-4" style={{ backgroundColor: '#F0EAE0' }}>
              <i className={`${item.icon} text-xl`} style={{ color: '#5C4F42' }}></i>
            </div>
            <p className="text-[13px] font-bold text-gray-800 mb-0.5">{item.titleZh}</p>
            <p className="text-[11px] mb-2" style={{ color: '#8C7D6E' }}>{item.titleKo}</p>
            <p className="text-[12px] text-gray-500 leading-relaxed">{item.descZh}</p>
          </div>
        ))}
      </div>

      {/* Brand Story Text */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
        <div className="rounded-2xl p-8" style={{ backgroundColor: '#F7F4F0', border: '1px solid #EDE8E0' }}>
          <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5" style={{ color: '#8C7D6E' }}>Brand Philosophy · 브랜드 철학</h4>
          <p className="text-[14px] leading-relaxed mb-4" style={{ color: '#5C4F42' }}>
            ATOPALM秉承<strong>"唤醒皮肤本源力量"</strong>的理念，专注于皮肤屏障修复。超越简单保湿，提供让皮肤自主维持健康的根本解决方案。
          </p>
          <p className="text-[13px] text-gray-500 leading-relaxed">
            아토팜은 "피부 본연의 힘을 되살린다"는 철학 아래, 피부 장벽 회복에 집중합니다. 단순한 보습을 넘어 피부가 스스로 건강을 유지할 수 있도록 근본적인 솔루션을 제공합니다.
          </p>
        </div>
        <div className="rounded-2xl p-8" style={{ backgroundColor: '#F7F4F0', border: '1px solid #EDE8E0' }}>
          <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-5" style={{ color: '#8C7D6E' }}>Target · 적합 대상</h4>
          <div className="space-y-3">
            {[
              { zh: '有特应性皮炎困扰的人群', ko: '아토피성 피부염으로 고민하는 분' },
              { zh: '皮肤敏感干燥的人群', ko: '민감하고 건조한 피부를 가진 분' },
              { zh: '需要新生儿·婴幼儿皮肤护理的人群', ko: '신생아·영유아 피부 케어가 필요한 분' },
              { zh: '需要孕期及产后皮肤护理的人群', ko: '임산부 및 산후 피부 케어가 필요한 분' },
            ].map((item, i) => (
              <div key={i} className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center rounded-full shrink-0 mt-0.5" style={{ backgroundColor: '#2E5240' }}>
                  <i className="ri-check-line text-white text-[10px]"></i>
                </div>
                <div>
                  <p className="text-[13px] font-medium text-gray-700">{item.zh}</p>
                  <p className="text-[11px]" style={{ color: '#8C7D6E' }}>{item.ko}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Awards & Certifications */}
      <div className="rounded-2xl p-8" style={{ backgroundColor: '#1a1a1a' }}>
        <h4 className="text-[11px] font-bold tracking-[0.25em] uppercase mb-6 text-center" style={{ color: '#8C7D6E' }}>Awards &amp; Certifications · 수상 및 인증</h4>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
          {[
            { icon: 'ri-award-fill', titleZh: '韩国优秀品牌', titleKo: '대한민국 우수 브랜드', year: '2023' },
            { icon: 'ri-medal-line', titleZh: '皮肤科学创新奖', titleKo: '피부과학 혁신상', year: '2022' },
            { icon: 'ri-shield-check-line', titleZh: 'EWG绿色等级认证', titleKo: 'EWG 그린 등급', year: '认证' },
            { icon: 'ri-star-line', titleZh: '消费者满意度第一', titleKo: '소비자 만족 1위', year: '2024' },
          ].map((item) => (
            <div key={item.titleZh} className="text-center p-4 rounded-xl" style={{ backgroundColor: 'rgba(255,255,255,0.04)', border: '1px solid rgba(255,255,255,0.06)' }}>
              <div className="w-10 h-10 flex items-center justify-center rounded-xl mx-auto mb-3" style={{ backgroundColor: 'rgba(200,184,154,0.15)' }}>
                <i className={`${item.icon} text-lg`} style={{ color: '#C8B89A' }}></i>
              </div>
              <p className="text-[12px] font-bold text-white mb-0.5">{item.titleZh}</p>
              <p className="text-[10px] mb-1" style={{ color: '#5A4A3A' }}>{item.titleKo}</p>
              <span className="text-[10px] font-bold px-2 py-0.5 rounded-full" style={{ backgroundColor: 'rgba(200,184,154,0.1)', color: '#C8B89A' }}>{item.year}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
